// Side bar V1
// Added The space
// import React, { useEffect, useState } from "react";
// import {
//   Link,
//   useLocation,
//   useNavigate,
//   useSearchParams,
// } from "react-router-dom";
// // Only add this import
// import {
//   Home,
//   BookOpen,
//   Calendar,
//   Briefcase,
//   Settings,
//   HelpCircle,
//   Star,
//   Trophy,
//   FileText,
//   MessageCircle,
//   ChevronDown,
//   ChevronRight,
//   Menu,
//   Users,
//   BarChart3,
//   GraduationCap,
//   LogOut,
//   User,
//   BanknoteArrowDown,
//   ReceiptIndianRupee,
//   FileCheck,
//   FileBadge,
//   Newspaper,
// } from "lucide-react";

// import sidebarData from "../../../../Assets/constants/sidebar_new.json";
// import Feedback from "../../../Dashboard/Sidebar/Modals/feedback";
// import ShareFeedback from "../../../Dashboard/Sidebar/Modals/share-feedback";
// import PID_MAP from "../../../../Assets/constants/inclusion_pid.json";

// // Icon mapping to convert string names to components
// const iconMap = {
//   Home,
//   BookOpen,
//   Calendar,
//   Briefcase,
//   Settings,
//   HelpCircle,
//   Star,
//   Trophy,
//   FileText,
//   MessageCircle,
//   Users,
//   BarChart3,
//   GraduationCap,
//   User,
//   BanknoteArrowDown,
//   ReceiptIndianRupee,
//   FileCheck,
//   FileBadge,
//   Newspaper,
// };

// const Avatar = ({ className = "", children }) => {
//   return (
//     <div
//       className={`relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full ${className}`}
//     >
//       {children} 
//     </div>
//   );
// };

// const AvatarFallback = ({ className = "", children }) => {
//   return (
//     <div
//       className={`flex h-full w-full items-center justify-center rounded-full bg-gray-100 text-gray-600 ${className}`}
//     >
//       {children}
//     </div>
//   );
// };

// // Custom Badge Component to replace Shadcn Badge
// const Badge = ({ children, className = "" }) => {
//   return (
//     <span
//       className={`inline-flex items-center px-2 py-1 text-xs font-medium bg-blue-600 text-white ${className}`}
//     >
//       {children}
//     </span>
//   );
// };

// const Sidebar = ({ isCollapsed, setIsCollapsed, showInclusionModal }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const [activeItem, setActiveItem] = useState("");
//   const [expandedSections, setExpandedSections] = useState({});
//   const [hoveredItems, setHoveredItems] = useState({});
//   const [showToggleTooltip, setShowToggleTooltip] = useState(false);
//   const [showUserTooltip, setShowUserTooltip] = useState(false);
//   const [showLogoutTooltip, setShowLogoutTooltip] = useState(false);
//   const [filteredSidebarData, setFilteredSidebarData] = useState([]);
//   const [isOpen, setIsOpen] = useState("");
//   const program_inclusion_pid = localStorage.getItem("program_id");
//   const program_inclusive_id = PID_MAP[program_inclusion_pid];
//   // Mock user data
//   const user = {
//     name:
//       localStorage.getItem("username") + " " + localStorage.getItem("lastname"),
//     email: localStorage.getItem("email"),
//     avatar: localStorage.getItem("profileURL"),
//   };

//   // useEffect(() => {
//   //   // Get category_id from localStorage
//   //   const userCategoryId = localStorage.getItem("category");

//   //   // If no category_id exists, show all items (or handle as needed)
//   //   if (!userCategoryId) {
//   //     setFilteredSidebarData(sidebarData);
//   //     return;
//   //   }

//   //   // Filter sidebar items based on category access
//   //   const filtered = sidebarData.filter((item) => {
//   //     // If categories array is empty, show to all users
//   //     if (!item.categories || item.categories.length === 0) {
//   //       return true;
//   //     }

//   //     // Check if user's category_id is in the item's categories array
//   //     return item.categories.includes(userCategoryId);
//   //   });

//   //   setFilteredSidebarData(filtered);
//   // }, []);
//   // useEffect(() => {
//   //   if (sidebarData.length > 0 && !activeItem) {
//   //     setActiveItem(sidebarData[0].id);
//   //   }
//   // }, []);

//   // useEffect(() => {
//   //   const userCategoryId = localStorage.getItem("category");
//   //   const userStatus = localStorage.getItem("status")?.toLowerCase();

//   //   if (!userCategoryId) {
//   //     setFilteredSidebarData(sidebarData);
//   //     return;
//   //   }

//   //   // Helper function to filter nested children recursively
//   //   const filterChildren = (items, allowedIds) => {
//   //     return items
//   //       .map((item) => {
//   //         // If item has children, recursively filter them
//   //         if (item.children && item.children.length > 0) {
//   //           const filteredChildren = item.children.filter((child) =>
//   //             allowedIds.includes(child.id)
//   //           );

//   //           // Only include parent if it has allowed children or is allowed itself
//   //           if (filteredChildren.length > 0 || allowedIds.includes(item.id)) {
//   //             return {
//   //               ...item,
//   //               children: filteredChildren,
//   //             };
//   //           }
//   //           return null;
//   //         }

//   //         // For items without children, check if they're allowed
//   //         return allowedIds.includes(item.id) ? item : null;
//   //       })
//   //       .filter(Boolean); // Remove null items
//   //   };

//   //   // Filter by category first
//   //   let filtered = sidebarData.filter((item) => {
//   //     if (!item.categories || item.categories.length === 0) {
//   //       return true;
//   //     }
//   //     return item.categories.includes(userCategoryId);
//   //   });

//   //   // If user is NOT active, filter to show only specific features
//   //   if (userStatus !== "active") {
//   //     const allowedFeaturesForInactive = [
//   //       "home",
//   //       "feedback",
//   //       "dashboard",
//   //       "manage-my-program", // Keep parent
//   //       "fee-recipt", // Keep this child
//   //       "due-fee-payment",
//   //       "program-inclusion",
//   //     ];

//   //     // Filter parent items and their children recursively
//   //     filtered = filterChildren(filtered, allowedFeaturesForInactive);
//   //   } else {
//   //     // For active users, still need to filter children by category
//   //     filtered = filtered.map((item) => {
//   //       if (item.children && item.children.length > 0) {
//   //         return {
//   //           ...item,
//   //           children: item.children.filter((child) => {
//   //             if (!child.categories || child.categories.length === 0) {
//   //               return true;
//   //             }
//   //             return child.categories.includes(userCategoryId);
//   //           }),
//   //         };
//   //       }
//   //       return item;
//   //     });
//   //   }

//   //   setFilteredSidebarData(filtered);
//   // }, []);

//   useEffect(() => {
//     const userCategoryId = localStorage.getItem("category");
//     const userStatus = localStorage.getItem("status")?.toLowerCase();

//     console.log("User Category ID:", userCategoryId);
//     console.log("User Status:", userStatus);

//     if (!userCategoryId) {
//       setFilteredSidebarData(sidebarData);
//       return;
//     }

//     // Helper function to check if an item should be visible
//     const isItemVisible = (item, categoryId) => {
//       // If no categories array or empty, show to all users
//       if (!item.categories || item.categories.length === 0) {
//         console.log(`${item.name}: No categories - visible to all`);
//         return true;
//       }
//       // Check if user's category is in the item's categories
//       const isVisible = item.categories.includes(categoryId);
//       console.log(
//         `${item.name}: ${isVisible ? "✓" : "✗"} (has ${
//           item.categories.length
//         } categories)`
//       );
//       return isVisible;
//     };

//     // For active users
//     if (userStatus === "active") {
//       const filtered = sidebarData
//         .filter((item) => isItemVisible(item, userCategoryId))
//         .map((item) => {
//           // If item has children, filter them based on their categories
//           if (item.children && item.children.length > 0) {
//             const filteredChildren = item.children.filter((child) =>
//               isItemVisible(child, userCategoryId)
//             );

//             // Only return parent if it has visible children
//             if (filteredChildren.length > 0) {
//               return {
//                 ...item,
//                 children: filteredChildren,
//               };
//             }
//             // If no children visible, don't show the parent dropdown
//             return null;
//           }
//           return item;
//         })
//         .filter(Boolean);

//       console.log("Filtered sidebar for active user:", filtered);
//       setFilteredSidebarData(filtered);
//     } else {
//       // For inactive users - show only specific features
//       const allowedFeaturesForInactive = [
//         "home",
//         "feedback",
//         "dashboard",
//         "share-feedback",
//         "manage-my-program",
//         "fee-recipt",
//         "due-fee-payment",
//         "program-inclusion",
//       ];

//       const filtered = sidebarData
//         .filter((item) => {
//           // Check if parent is allowed
//           if (!allowedFeaturesForInactive.includes(item.id)) {
//             return false;
//           }
//           // Check category visibility
//           return isItemVisible(item, userCategoryId);
//         })
//         .map((item) => {
//           // If item has children, filter by both allowed IDs and categories
//           if (item.children && item.children.length > 0) {
//             const filteredChildren = item.children.filter((child) => {
//               // Check if child is in allowed list
//               const isAllowed = allowedFeaturesForInactive.includes(child.id);
//               // Check category visibility
//               const hasAccess = isItemVisible(child, userCategoryId);
//               return isAllowed && hasAccess;
//             });

//             if (filteredChildren.length > 0) {
//               return {
//                 ...item,
//                 children: filteredChildren,
//               };
//             }
//             return null;
//           }
//           return item;
//         })
//         .filter(Boolean);

//       console.log("Filtered sidebar for inactive user:", filtered);
//       setFilteredSidebarData(filtered);
//     }
//   }, []);

//   useEffect(() => {
//     if (filteredSidebarData.length > 0 && !activeItem) {
//       setActiveItem(filteredSidebarData[0].id);
//     }
//   }, [filteredSidebarData, activeItem]); // ✅ Add dependencies

//   useEffect(() => {
//     // Check for tab query parameter first
//     const tabParam = searchParams.get("tab");
//     if (tabParam) {
//       setActiveItem(tabParam);
//       return;
//     }

//     // Fallback to pathname matching
//     const currentPath = location.pathname;

//     for (const item of filteredSidebarData) {
//       if (item.link === currentPath) {
//         setActiveItem(item.id);
//         return;
//       }

//       if (item.children) {
//         for (const child of item.children) {
//           if (child.link === currentPath) {
//             const childId =
//               child.id ||
//               `${item.id}-${child.name.toLowerCase().replace(/\s+/g, "-")}`;
//             setActiveItem(childId);
//             setExpandedSections((prev) => ({
//               ...prev,
//               [item.name]: true,
//             }));
//             return;
//           }
//         }
//       }
//     }

//     if (filteredSidebarData.length > 0 && !activeItem) {
//       setActiveItem(filteredSidebarData[0].id);
//     }
//   }, [searchParams, location.pathname, filteredSidebarData, activeItem]); // ✅ Add all dependencies

//   const toggleSection = (itemName) => {
//     setExpandedSections((prev) => ({
//       ...prev,
//       [itemName]: !prev[itemName],
//     }));
//   };

//   const handleLogout = () => {
//     console.log("Logging out...");
//   };

//   const LogOutUser = (name, domain) => {
//     document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/;`;
//     localStorage.clear();
//     window.location.href = "https://accredian.com";
//   };

//   const handleItemHover = (itemName, isHovered) => {
//     setHoveredItems((prev) => ({
//       ...prev,
//       [itemName]: isHovered,
//     }));
//   };

//   const handleItemClick = (item, parentId = null) => {
//     // Generate unique ID for child items
//     if (item.type === "modal") {
//       setIsOpen(item.id); // This will set "shareFeedback" as the value
//       return;
//     }

//     if (item.type === "external" && item.id == "events-calendar") {
//       const newemail = btoa(localStorage.getItem("email"));
//       window.open(item.link + newemail, "_blank");
//       return;
//     }

//     if (item.type === "external") {
//       window.open(item.link, "_blank");
//       return;
//     }

//     if (item.type === "inclusion") {
//       window.open(item.link + "/" + program_inclusive_id, "_blank");
//       return;
//     }
//     console.log("came here");
//     const itemId = parentId
//       ? item.id || `${parentId}-${item.name.toLowerCase().replace(/\s+/g, "-")}`
//       : item.id;

//     setActiveItem(itemId);
//   };

//   const handleTabClick = (tabName) => {
//     navigate(`/?tab=${tabName}`);
//     setActiveItem(tabName);
//   };

//   // Component to render tooltip content for items with children
//   const renderTooltipContent = (item) => {
//     if (!item.children || item.children.length === 0) {
//       return <p className="text-sm text-gray-600 font-medium">{item.name}</p>;
//     }

//     return (
//       <div className="space-y-2 p-1">
//         <p className="text-sm font-semibold border-b border-gray-300 pb-1">
//           {item.name}
//         </p>
//         <div className="space-y-1">
//           {item.children.map((child, index) => {
//             const ChildIcon = iconMap[child.icon] || Settings;
//             return (
//               <div
//                 key={index}
//                 className="flex items-center gap-2 px-2 py-1 rounded hover:bg-gray-700 transition-colors cursor-pointer"
//               >
//                 <ChildIcon className="w-4 h-4 text-gray-500" />
//                 <span className="text-sm font-semibold text-gray-500">
//                   {child.name}
//                 </span>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   const renderNavItem = (item, isChild = false, parentId = null) => {
//     const itemKey = `${item.name}-${isChild}`;
//     const isHovered = hoveredItems[itemKey];
//     const IconComponent = iconMap[item.icon] || Settings;

//     // Generate unique ID for child items
//     const itemId =
//       isChild && parentId
//         ? item.id ||
//           `${parentId}-${item.name.toLowerCase().replace(/\s+/g, "-")}`
//         : item.id;

//     const isActive = activeItem === itemId;

//     const navItemContent = (
//       <div
//         className={`flex items-center gap-3 p-3 rounded-lg transition-all duration-200 cursor-pointer group ${
//           isChild ? "ml-6" : ""
//         } ${
//           isActive
//             ? "bg-blue-600 text-white shadow-sm"
//             : "hover:bg-gray-100 hover:text-gray-900 text-gray-600"
//         }`}
//         onClick={(e) => {
//           if (item.children && !isChild) {
//             toggleSection(item.name);
//           } else {
//             handleItemClick(item, parentId);
//           }
//         }}
//         onMouseEnter={() => handleItemHover(itemKey, true)}
//         onMouseLeave={() => handleItemHover(itemKey, false)}
//       >
//         <IconComponent
//           className={`w-5 h-5 flex-shrink-0 ${
//             isActive ? "text-white" : "text-gray-500 group-hover:text-gray-900"
//           }`}
//         />

//         {!isCollapsed && (
//           <>
//             <span
//               className={`text-sm font-medium flex-1 ${
//                 isActive
//                   ? "text-white"
//                   : "text-gray-600 group-hover:text-gray-900"
//               }`}
//             >
//               {item.name}
//             </span>

//             <div className="flex items-center gap-2">
//               {item.badge && (
//                 <Badge className="text-xs px-2 rounded-full py-1 bg-red-500 text-white">
//                   {item.badge}
//                 </Badge>
//               )}
//               {item.isNew && (
//                 <Badge className="text-xs px-2 rounded-full py-1 bg-blue-600 text-white">
//                   New
//                 </Badge>
//               )}
//               {item.children &&
//                 (expandedSections[item.name] ? (
//                   <ChevronDown className="w-4 h-4" />
//                 ) : (
//                   <ChevronRight className="w-4 h-4" />
//                 ))}
//             </div>
//           </>
//         )}
//       </div>
//     );

//     // Only add Link wrapper if item has a link property
//     const finalContent =
//       item.link &&
//       item.type !== "modal" &&
//       item.type !== "external" &&
//       item.type !== "inclusion" ? (
//         <Link
//           to={item.link}
//           style={{ textDecoration: "none", color: "inherit" }}
//         >
//           {navItemContent}
//         </Link>
//       ) : (
//         navItemContent
//       );

//     return (
//       <div key={item.name} className="relative">
//         {finalContent}

//         {/* Nested children */}
//         {item.children &&
//           expandedSections[item.name] &&
//           !isCollapsed &&
//           item.children.map((child) => (
//             <div key={child.name}>
//               {child.link && child.type !== "inclusion" ? (
//                 <Link
//                   to={child.link}
//                   style={{ textDecoration: "none", color: "inherit" }}
//                 >
//                   {renderNavItem(child, true, item.id)}
//                 </Link>
//               ) : (
//                 renderNavItem(child, true, item.id)
//               )}
//             </div>
//           ))}
//       </div>
//     );
//   };

//   return (
//     <>
//       <div
//         className={`hidden md:fixed left-0 top-0 h-screen bg-white border-r border-gray-200 shadow-lg z-50 transition-all duration-300 md:flex md:flex-col ${
//           isCollapsed ? "w-20" : "w-64"
//         }`}
//       >
//         {/* Header with Toggle */}
//         <div className="flex items-center justify-between p-[12px] border-b border-gray-200">
//           {!isCollapsed && (
//             <img
//               className="h-10 ml-1"
//               src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/other/logo.webp"
//               alt="Accredian"
//             />
//           )}
//           <div className="relative">
//             <button
//               onClick={() => setIsCollapsed(!isCollapsed)}
//               className="p-2 rounded-lg hover:bg-gray-100 transition-colors group"
//               onMouseEnter={() => setShowToggleTooltip(true)}
//               onMouseLeave={() => setShowToggleTooltip(false)}
//             >
//               <Menu className="w-6 h-6 mb-2" />
//             </button>
//           </div>
//         </div>

//         {/* Navigation - Scrollable */}
//         <nav className="flex-1 p-4 space-y-1 overflow-y-auto custom-scrollbar">
//           {location.pathname === "/" ? (
//             // Render only 2 tabs for home page
//             <>
//               <button
//                 onClick={() => handleTabClick("my-courses")}
//                 className={`w-full flex items-center ${
//                   isCollapsed ? "justify-center" : "justify-between"
//                 } gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
//                   activeItem === "my-courses"
//                     ? "bg-blue-600 text-white"
//                     : "text-gray-700 hover:bg-gray-100"
//                 }`}
//               >
//                 <div className="flex items-center gap-3">
//                   <BookOpen size={20} />
//                   {!isCollapsed && (
//                     <span className="font-medium">My Courses</span>
//                   )}
//                 </div>
//               </button>

//               <button
//                 onClick={() => handleTabClick("my-applications")}
//                 className={`w-full flex items-center ${
//                   isCollapsed ? "justify-center" : "justify-between"
//                 } gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
//                   activeItem === "my-applications"
//                     ? "bg-blue-600 text-white"
//                     : "text-gray-700 hover:bg-gray-100"
//                 }`}
//               >
//                 <div className="flex items-center gap-3">
//                   <FileText size={20} />
//                   {!isCollapsed && (
//                     <span className="font-medium">My Applications</span>
//                   )}
//                 </div>
//               </button>
//             </>
//           ) : (
//             // Render normal sidebar items
//             // sidebarData.map((item) => renderNavItem(item))
//             <>
//               {filteredSidebarData.map((item) => renderNavItem(item))}
//               <Feedback open={isOpen} setOpen={setIsOpen} />
//               <ShareFeedback open={isOpen} setOpen={setIsOpen} />
//             </>
//           )}
//         </nav>

//         {/* User Profile Section - Sticky at bottom */}
//         <div className="border-t border-gray-200 p-4 bg-white">
//           {isCollapsed ? (
//             <div className="flex flex-col items-center space-y-2">
//               <div
//                 className="relative group"
//                 onMouseEnter={() => setShowUserTooltip(true)}
//                 onMouseLeave={() => setShowUserTooltip(false)}
//               >
//                 <Avatar className="w-8 h-8 ring-2 ring-gray-200 cursor-pointer hover:ring-blue-600 transition-colors">
//                   {user.avatar ? (
//                     <img
//                       src={user.avatar}
//                       alt={user.name}
//                       className="w-full h-full object-cover"
//                     />
//                   ) : (
//                     <AvatarFallback className="bg-gray-100 text-gray-600">
//                       {(() => {
//                         const nameParts = user.name.trim().split(" ");
//                         const firstInitial = nameParts[0]?.charAt(0) || "";
//                         const lastInitial =
//                           localStorage
//                             .getItem("lastname")
//                             ?.split(" ")[0]
//                             ?.charAt(0) || "";
//                         return (firstInitial + lastInitial).toUpperCase();
//                       })()}
//                     </AvatarFallback>
//                   )}
//                 </Avatar>
//               </div>

//               <div className="relative group">
//                 <button
//                   onClick={() => {
//                     LogOutUser("token", "accredian.com");
//                   }}
//                   className="p-2 rounded-lg hover:bg-gray-100 transition-colors group"
//                   onMouseEnter={() => setShowLogoutTooltip(true)}
//                   onMouseLeave={() => setShowLogoutTooltip(false)}
//                 >
//                   <LogOut className="w-4 h-4 text-gray-500 group-hover:text-gray-900" />
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <div className="space-y-3">
//               {/* User Info */}
//               <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
//                 <Avatar className="w-10 h-10 ring-2 ring-gray-200">
//                   {user.avatar ? (
//                     <img
//                       src={user.avatar}
//                       alt={user.name}
//                       className="w-full h-full object-cover"
//                     />
//                   ) : (
//                     <AvatarFallback className="bg-gray-100 text-gray-600">
//                       {(() => {
//                         const nameParts = user.name.trim().split(" ");
//                         const firstInitial = nameParts[0]?.charAt(0) || "";
//                         const lastInitial =
//                           localStorage
//                             .getItem("lastname")
//                             ?.split(" ")[0]
//                             ?.charAt(0) || "";
//                         console.log(
//                           localStorage.getItem("lastname")?.split(" ")[0]
//                         );
//                         return (firstInitial + lastInitial).toUpperCase();
//                       })()}
//                     </AvatarFallback>
//                   )}
//                 </Avatar>
//                 <div className="flex-1 min-w-0">
//                   <p className="text-sm font-medium text-gray-900 truncate">
//                     {user.name}
//                   </p>
//                   <p className="text-xs text-gray-500 truncate">{user.email}</p>
//                 </div>
//               </div>

//               {/* Logout Button */}
//               <button
//                 onClick={() => {
//                   LogOutUser("token", "accredian.com");
//                 }}
//                 className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-red-50 hover:text-red-600 transition-colors group"
//               >
//                 <LogOut className="w-4 h-4" />
//                 <span className="text-sm font-medium">Logout</span>
//               </button>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Tooltip Portal Container - Renders tooltips outside sidebar */}
//       {isCollapsed && (
//         <div className="fixed inset-0 pointer-events-none z-[9999]">
//           {/* Toggle Tooltip */}
//           {showToggleTooltip && (
//             <div
//               className="absolute bg-white text-gray-600 px-3 py-2 text-sm rounded-md shadow-lg whitespace-nowrap pointer-events-none"
//               style={{
//                 left: "88px",
//                 top: "24px",
//                 transform: "translateY(-50%)",
//               }}
//             >
//               Expand Sidebar
//               <div className="absolute w-2 h-2 bg-white transform rotate-45 -left-1 top-1/2 -translate-y-1/2" />
//             </div>
//           )}

//           {/* Navigation Item Tooltips */}
//           {Object.entries(hoveredItems).map(([itemKey, isHovered]) => {
//             if (!isHovered) return null;

//             const [itemName] = itemKey.split("-");
//             // const item = sidebarData.find((nav) => nav.name === itemName);
//             const item = filteredSidebarData.find(
//               (nav) => nav.name === itemName
//             );

//             if (!item) return null;

//             // const itemIndex = sidebarData.findIndex(
//             //   (nav) => nav.name === itemName
//             // );
//             const itemIndex = filteredSidebarData.findIndex(
//               (nav) => nav.name === itemName
//             );
//             const topOffset = 60 + itemIndex * 56 + 28; // Header height + item position + half item height

//             return (
//               <div
//                 key={itemKey}
//                 className="absolute bg-white text-gray-600 px-3 py-2 rounded-md shadow-lg max-w-xs pointer-events-none"
//                 style={{
//                   left: "88px",
//                   top: `${topOffset}px`,
//                   transform: "translateY(-50%)",
//                 }}
//               >
//                 {renderTooltipContent(item)}
//                 <div className="absolute w-2 h-2 bg-white transform rotate-45 -left-1 top-1/2 -translate-y-1/2" />
//               </div>
//             );
//           })}

//           {/* User Profile Tooltip */}
//           {showUserTooltip && (
//             <div
//               className="absolute bg-white text-gray-600 px-3 py-2 rounded-md shadow-lg whitespace-nowrap pointer-events-none"
//               style={{
//                 left: "88px",
//                 bottom: "60px",
//                 transform: "translateY(0%)",
//               }}
//             >
//               <div className="text-center">
//                 <p className="text-sm text-gray-600 font-medium">{user.name}</p>
//                 <p className="text-xs text-gray-600">{user.email}</p>
//               </div>
//               <div className="absolute w-2 h-2 bg-white transform rotate-45 -left-1 top-1/2 -translate-y-1/2" />
//             </div>
//           )}

//           {/* Logout Tooltip */}
//           {showLogoutTooltip && (
//             <div
//               className="absolute  bg-white text-gray-600 px-3 py-2 rounded-md shadow-lg whitespace-nowrap pointer-events-none"
//               style={{
//                 left: "88px",
//                 bottom: "16px",
//                 transform: "translateY(0%)",
//               }}
//             >
//               Logout
//               <div className="absolute w-2 h-2 bg-white transform rotate-45 -left-1 top-1/2 -translate-y-1/2" />
//             </div>
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default Sidebar;












import React, { useEffect, useState, useRef } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
// Only add this import
import {
  Home,
  BookOpen,
  Calendar,
  Briefcase,
  Settings,
  HelpCircle,
  Star,
  Trophy,
  FileText,
  MessageCircle,
  ChevronDown,
  ChevronRight,
  Menu,
  Users,
  BarChart3,
  GraduationCap,
  LogOut,
  User,
  BanknoteArrowDown,
  ReceiptIndianRupee,
  FileCheck,
  FileBadge,
  Newspaper,
  NotepadTextDashed,
  BriefcaseBusiness,
  BookMarked,
  School,
  Check,
  X
} from "lucide-react";

import sidebarData from "../../../../Assets/constants/sidebar_new.json";
import Feedback from "../../../Dashboard/Sidebar/Modals/feedback";
import ShareFeedback from "../../../Dashboard/Sidebar/Modals/share-feedback";
import PID_MAP from "../../../../Assets/constants/inclusion_pid.json";
import { useQuery } from "@tanstack/react-query";
import { fetchCareerCounselingStatusService } from "../../../../services/users.services";

// Icon mapping to convert string names to components
export const iconMap = {
  Home,
  BookOpen,
  Calendar,
  Briefcase,
  Settings,
  HelpCircle,
  Star,
  Trophy,
  FileText,
  MessageCircle,
  Users,
  BarChart3,
  GraduationCap,
  User,
  BanknoteArrowDown,
  ReceiptIndianRupee,
  FileCheck,
  FileBadge,
  Newspaper,
  NotepadTextDashed,
  BriefcaseBusiness,
  BookMarked,
  School
};

export const Avatar = ({ className = "", children }) => {
  return (
    <div
      className={`relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full ${className}`}
    >
      {children}
    </div>
  );
};

export const AvatarFallback = ({ className = "", children }) => {
  return (
    <div
      className={`flex h-full w-full items-center justify-center rounded-full bg-gray-100 text-gray-600 ${className}`}
    >
      {children}
    </div>
  );
};

// Custom Badge Component to replace Shadcn Badge
const Badge = ({ children, className = "" }) => {
  return (
    <span
      className={`inline-flex items-center font-medium ${className}`}
    >
      {children}
    </span>
  );
};

const Sidebar = ({ isCollapsed, setIsCollapsed, showInclusionModal, hasActivePlan, showAgreementModal }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [activeItem, setActiveItem] = useState("");
  const [activeParent, setActiveParent] = useState("");
  const [expandedSections, setExpandedSections] = useState({});
  const [filteredSidebarData, setFilteredSidebarData] = useState([]);
  const [isOpen, setIsOpen] = useState("");
  const [tempExpanded, setTempExpanded] = useState(false);
  const [expandTimeout, setExpandTimeout] = useState(null);

  const feedbackItemRef = useRef(null);
  const [showCoach, setShowCoach] = useState(false);
  const [targetRect, setTargetRect] = useState(null);

  const category_id = localStorage.getItem("category");
  const program_id = localStorage.getItem("program_id");
  const batch_id = localStorage.getItem("batch_id");

  const { data: careerCounselingStatus } = useQuery({
    queryFn: () =>
      fetchCareerCounselingStatusService({
        category: category_id,
        program_id: program_id,
        batch_id: batch_id,
      }),
    queryKey: ["get-career-counseling-status"],
    enabled: !!category_id && !!program_id && !!batch_id,
  });

  const isBatchFromSept2026Onwards = () => {
    try {
      const batchDateStr = localStorage.getItem("batch");
      if (!batchDateStr || batchDateStr === "undefined" || batchDateStr === "null") {
        return false;
      }
      const match = String(batchDateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        const year = match[1];
        const month = match[2];
        const day = match[3];
        return `${year}-${month}-${day}` >= "2026-09-01";
      }
      const batchDate = new Date(batchDateStr);
      if (isNaN(batchDate.getTime())) return false;
      return batchDate >= new Date("2026-09-01");
    } catch (e) {
      return false;
    }
  };

  const isBatchOlderThan100Days = () => {
    try {
      const batchDateStr = localStorage.getItem("batch");
      if (!batchDateStr) return false;
      const batchDate = new Date(batchDateStr);
      if (isNaN(batchDate.getTime())) return false;
      const diffTime = Math.abs(new Date() - batchDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays >= 100;
    } catch (e) {
      return false;
    }
  };

  const categoryMap = [24, 22, 18, 27, 4];
  const batchMap = [91, 90, 97, 84, 103, 110, 118, 121, 123, 157];
  const programMap = [42, 43, 60, 61, 63, 69, 72, 75, 79, 88, 92, 102, 157, 97];

  const isCareerCounselingActive = Boolean(
    isBatchFromSept2026Onwards()
      ? (careerCounselingStatus?.is_active || isBatchOlderThan100Days())
      : (categoryMap.includes(Number(category_id)) &&
          batchMap.includes(Number(batch_id)) &&
          programMap.includes(Number(program_id)))
  );

  useEffect(() => {
    const isDismissed = localStorage.getItem("feedback_moved_coach_dismissed") === "true";
    if (!isDismissed) {
      const timer = setTimeout(() => {
        setShowCoach(true);
      }, 600);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (!showCoach) return;

    const updatePosition = () => {
      const element = feedbackItemRef.current;
      if (!element) return;
      const rect = element.getBoundingClientRect();
      setTargetRect({
        top: rect.top + rect.height / 2,
        left: rect.right + 20
      });
    };

    // Small delay to ensure rendering is complete
    const timeoutId = setTimeout(updatePosition, 100);

    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [showCoach]);

  const handleDismissCoach = () => {
    localStorage.setItem("feedback_moved_coach_dismissed", "true");
    setShowCoach(false);
  };

  const inclusion_link = localStorage.getItem("inclusion_link");
  const program_inclusion_pid = localStorage.getItem("program_id");
  const program_inclusive_id = PID_MAP[program_inclusion_pid];

  // Mock user data
  const user = {
    name:
      localStorage.getItem("username") + " " + localStorage.getItem("lastname"),
    email: localStorage.getItem("email"),
    avatar: localStorage.getItem("profileURL"),
  };

  // useEffect(() => {
  //   // Get category_id from localStorage

  //   const userCategoryId = localStorage.getItem("category");

  //   // If no category_id exists, show all items (or handle as needed)
  //   if (!userCategoryId) {
  //     setFilteredSidebarData(sidebarData);
  //     return;
  //   }

  //   // Filter sidebar items based on category access
  //   const filtered = sidebarData.filter((item) => {
  //     // If categories array is empty, show to all users
  //     if (!item.categories || item.categories.length === 0) {
  //       return true;
  //     }

  //     // Check if user's category_id is in the item's categories array
  //     return item.categories.includes(userCategoryId);
  //   });

  //   setFilteredSidebarData(filtered);
  // }, []);
  // useEffect(() => {
  //   if (sidebarData.length > 0 && !activeItem) {
  //     setActiveItem(sidebarData[0].id);
  //   }
  // }, []);

  // useEffect(() => {
  //   const userCategoryId = localStorage.getItem("category");
  //   const userStatus = localStorage.getItem("status")?.toLowerCase();

  //   if (!userCategoryId) {
  //     setFilteredSidebarData(sidebarData);
  //     return;
  //   }

  //   // Helper function to filter nested children recursively
  //   const filterChildren = (items, allowedIds) => {
  //     return items
  //       .map((item) => {
  //         // If item has children, recursively filter them
  //         if (item.children && item.children.length > 0) {
  //           const filteredChildren = item.children.filter((child) =>
  //             allowedIds.includes(child.id)
  //           );

  //           // Only include parent if it has allowed children or is allowed itself
  //           if (filteredChildren.length > 0 || allowedIds.includes(item.id)) {
  //             return {
  //               ...item,
  //               children: filteredChildren,
  //             };
  //           }
  //           return null;
  //         }

  //         // For items without children, check if they're allowed
  //         return allowedIds.includes(item.id) ? item : null;
  //       })
  //       .filter(Boolean); // Remove null items
  //   };

  //   // Filter by category first
  //   let filtered = sidebarData.filter((item) => {
  //     if (!item.categories || item.categories.length === 0) {
  //       return true;
  //     }
  //     return item.categories.includes(userCategoryId);
  //   });

  //   // If user is NOT active, filter to show only specific features
  //   if (userStatus !== "active") {
  //     const allowedFeaturesForInactive = [
  //       "home",
  //       "feedback",
  //       "dashboard",
  //       "manage-my-program", // Keep parent
  //       "fee-recipt", // Keep this child
  //       "due-fee-payment",
  //       "program-inclusion",
  //     ];

  //     // Filter parent items and their children recursively
  //     filtered = filterChildren(filtered, allowedFeaturesForInactive);
  //   } else {
  //     // For active users, still need to filter children by category
  //     filtered = filtered.map((item) => {
  //       if (item.children && item.children.length > 0) {
  //         return {
  //           ...item,
  //           children: item.children.filter((child) => {
  //             if (!child.categories || child.categories.length === 0) {
  //               return true;
  //             }
  //             return child.categories.includes(userCategoryId);
  //           }),
  //         };
  //       }
  //       return item;
  //     });
  //   }

  //   setFilteredSidebarData(filtered);
  // }, []);

  // // At the top of Sidebar.jsx, add this useEffect
  // useEffect(() => {
  //   const handleEnrollmentChange = () => {
  //     // Force component re-render by updating category from localStorage
  //     const newCategory = localStorage.getItem("category");
  //     // This will trigger your existing category-based logic
  //     window.location.reload(); // Or use state management to update
  //   };

  //   window.addEventListener('enrollmentChanged', handleEnrollmentChange);
  //   return () => window.removeEventListener('enrollmentChanged', handleEnrollmentChange);
  // }, []);



  useEffect(() => {
    if (showAgreementModal) {
      const agreementLockedItems = sidebarData.filter(
        (item) => item.id === "dashboard" || item.id === "my-applications"
      );
      setFilteredSidebarData(agreementLockedItems);
      return;
    }

    const userCategoryId = localStorage.getItem("category");
    const userStatus = localStorage.getItem("status")?.toLowerCase();
    const term = Number(localStorage.getItem("term"));
    const university = localStorage.getItem("university")?.toLowerCase();
    const programId = Number(localStorage.getItem("program_id"));
    const batchId = Number(localStorage.getItem("batch_id"));
    const userId = localStorage.getItem("user_id");



    // Define allowed batch/program combinations for specific features
    const featureAccess = {
      "ai-resume-builder": [
        { batchId: 138, programId: 118 },
        { batchId: 146, programId: 42 },
        { batchId: 138, programId: 119 },

        { batchId: 142, programId: 69 },
        { batchId: 123, programId: 69 },
        { batchId: 147, programId: 110 },
        { batchId: 129, programId: 110 },
        { batchId: 129, programId: 103 },
        { batchId: 138, programId: 112 },
        { batchId: 148, programId: 118 },
        { batchId: 142, programId: 123 },
        { batchId: 142, programId: 121 },
        { batchId: 160, programId: 124 },
        { batchId: 129, programId: 109 },
        { batchId: 131, programId: 69 },
        { batchId: 167, programId: 130 },
        { batchId: 158, programId: 132 },
        { batchId: 158, programId: 133 },
        { batchId: 148, programId: 119 },
        { batchId: 148, programId: 118 },
        { batchId: 156, programId: 128 },
        { batchId: 156, programId: 129 }
      ],
      // Add more features here as needed
    };

    console.log("User Category ID:", userCategoryId);
    console.log("User Status:", userStatus);

    if (!userCategoryId) {
      // No enrollment — only show Dashboard and My Application
      const noEnrollmentItems = sidebarData.filter(item =>
        item.id === "dashboard" || item.id === "my-applications"
      );
      setFilteredSidebarData(noEnrollmentItems);
      return;
    }


    // Helper function to check if an item should be visible
    const isItemVisible = (item, categoryId) => {
      if (item.id === "my-applications" && String(categoryId) === "59") {
        return false;
      }
      if (
        (item.id === "certificate-exam" || item.name === "Certification Exam" || item.title === "Certification Exam") &&
        batchId > 125 &&
        [2, 4, 11, 27, 35, 36].includes(Number(categoryId))
      ) {
        return false;
      }
      if (
        (item.id === "career-counselling" || item.name === "Career Counselling") &&
        isCareerCounselingActive
      ) {
        return true;
      }
      // If no categories array or empty, show to all users
      if (!item.categories || item.categories.length === 0) {
        console.log(`${item.name}: No categories - visible to all`);
        return true;
      }
      // Check if user's category is in the item's categories
      const isVisible = item.categories.includes(categoryId);
      console.log(
        `${item.name}: ${isVisible ? "✓" : "✗"} (has ${item.categories.length
        } categories)`
      );
      return isVisible;
    };

    // For active users
    if (userStatus === "active" && !showInclusionModal) {
      let filtered = sidebarData
        .filter((item) => isItemVisible(item, userCategoryId))
        .map((item) => {
          // If item has children, filter them based on their categories
          if (item.children && item.children.length > 0) {
            let filteredChildren = item.children.filter((child) => {
              const hasCategoryAccess = isItemVisible(child, userCategoryId);

              if (featureAccess[child.id] && hasCategoryAccess) {
                return (
                  userId === "44841" ||
                  featureAccess[child.id].some(
                    (combo) => combo.batchId === batchId && combo.programId === programId
                  )
                );
              }
              return hasCategoryAccess;
            });

            // Hide Installment Tracker if no active plan
            if (!hasActivePlan) {
              filteredChildren = filteredChildren.filter(
                (child) => child.id !== "installment-tracker"
              );
            }

            const isCareerAllowed = Boolean(
              isCareerCounselingActive ||
              (Number(userCategoryId) === 45 && Number(localStorage.getItem("batch_id")) === 156 && Number(programId) === 129) ||
              (Number(userCategoryId) === 24 && ((Number(localStorage.getItem("batch_id")) === 157 && Number(programId) === 97) || (Number(localStorage.getItem("batch_id")) === 97 && Number(programId) === 157))) ||
              (Number(localStorage.getItem("batch_id")) === 142 && Number(programId) === 69) ||
              userId === "44841" ||
              userId === "37635"
            );

            if (item.id === "career" && term < 3 && !isCareerAllowed) {
              filteredChildren = filteredChildren.filter(
                (child) => child.name !== "Career Counselling"
              );
            }

            // Rename Program Upgrade to Plan Your Next Move if progress > 75
            try {
              let userProgress = null;
              const directKeys = [
                "curriculum_percent",
                "curriculum_progress",
                "progress_percentage",
                "course_progress",
                "progress",
              ];
              for (const k of directKeys) {
                const val = localStorage.getItem(k);
                if (val !== null && val !== undefined && val !== "") {
                  const num = parseFloat(val);
                  if (!isNaN(num)) {
                    userProgress = num;
                    break;
                  }
                }
              }
              if (userProgress === null) {
                const isComp = localStorage.getItem("is_completed");
                if (isComp === "1" || isComp === "true" || isComp === 1) {
                  userProgress = 100;
                } else {
                  const stored = localStorage.getItem("courseDetails");
                  if (stored) {
                    const parsed = JSON.parse(stored);
                    if (parsed?.terms && Array.isArray(parsed.terms) && parsed.terms.length > 0) {
                      const totalTerms = parsed.terms.length;
                      const activeTerm = Number(parsed.active_term ?? localStorage.getItem("term") ?? 1);
                      userProgress = Math.round((Math.max(0, activeTerm - 1) / totalTerms) * 100);
                    }
                  }
                }
              }
              if (userProgress !== null && userProgress > 75) {
                filteredChildren = filteredChildren.map((child) =>
                  child.id === "program-upgrade"
                    ? { ...child, name: "Plan Your Next Move" }
                    : child
                );
              }
            } catch (e) {
              console.error("Error setting dynamic Plan Your Next Move in sidebar:", e);
            }

            // Only return parent if it has visible children
            if (filteredChildren.length > 0) {
              return {
                ...item,
                children: filteredChildren,
              };
            }
            // If no children visible, don't show the parent dropdown
            return null;
          }
          return item;
        })
        .filter(Boolean);

      // Move "Share Feedback" and "My Application" to the end
      const specialItems = ["share-feedback", "my-applications"];
      const bottomItems = filtered.filter(item => specialItems.includes(item.id));
      const mainItems = filtered.filter(item => !specialItems.includes(item.id));

      filtered = [...mainItems, ...bottomItems];

      console.log("Filtered sidebar for active user:", filtered);
      setFilteredSidebarData(filtered);
    } else {
      // For inactive users - show only specific features
      let allowedFeaturesForInactive = [
        "dashboard",
        "my-applications",
        "manage-my-program",
      ];

      const isRestrictedUniversity = university === 'iitk' || university === 'xlri';
      if (!isRestrictedUniversity) {
        allowedFeaturesForInactive.push(
          "fee-recipt",
          "due-fee-payment",
          "home",
          "feedback"
        );
        // Only show installment tracker if there is an active plan
        if (hasActivePlan) {
          allowedFeaturesForInactive.push("installment-tracker");
        }
      }

      if (showInclusionModal) {
        allowedFeaturesForInactive = allowedFeaturesForInactive.filter(
          (id) => id !== "manage-my-program"
        );
      }

      const filtered = sidebarData
        .filter((item) => {
          // Check if parent is allowed
          // Handle Manage My Program missing ID issue
          const itemId = item.id || (item.name === "Manage My Program" ? "manage-my-program" : item.id);

          if (!allowedFeaturesForInactive.includes(itemId)) {
            return false;
          }

          if (["dashboard", "my-applications"].includes(item.id)) {
            return true;
          }

          // Check category visibility
          return isItemVisible(item, userCategoryId);
        })
        .map((item) => {
          // If item has children, filter by both allowed IDs and categories
          if (item.children && item.children.length > 0) {
            const filteredChildren = item.children.filter((child) => {
              // Check if child is in allowed list
              const isAllowed = allowedFeaturesForInactive.includes(child.id);
              // Check category visibility
              const hasAccess = isItemVisible(child, userCategoryId);
              return isAllowed && hasAccess;
            });

            if (filteredChildren.length > 0) {
              return {
                ...item,
                children: filteredChildren,
              };
            }
            return null;
          }
          return item;
        })
        .filter(Boolean);

      console.log("Filtered sidebar for inactive user:", filtered);
      setFilteredSidebarData(filtered);
    }
  }, [showInclusionModal, hasActivePlan, showAgreementModal, isCareerCounselingActive]);

  useEffect(() => {
    if (filteredSidebarData.length > 0 && !activeItem) {
      setActiveItem(filteredSidebarData[0].id);
    }
  }, [filteredSidebarData, activeItem]); // ✅ Add dependencies

  useEffect(() => {
    // Check for tab query parameter first
    const tabParam = searchParams.get("tab");
    if (tabParam) {
      setActiveItem(tabParam);
      return;
    }

    // Fallback to pathname matching
    const currentPath = location.pathname;

    for (const item of filteredSidebarData) {
      if (item.link === currentPath) {
        setActiveItem(item.id);
        setActiveParent("");
        return;
      }

      if (item.children) {
        for (const child of item.children) {
          if (child.link === currentPath) {
            const childId =
              child.id ||
              `${item.id}-${child.name.toLowerCase().replace(/\s+/g, "-")}`;
            setActiveItem(childId);
            setActiveParent(item.id);
            setExpandedSections((prev) => ({
              ...prev,
              [item.name]: true,
            }));
            return;
          }
        }
      }
    }

    if (filteredSidebarData.length > 0 && !activeItem) {
      setActiveItem(filteredSidebarData[0].id);
    }
  }, [searchParams, location.pathname, filteredSidebarData, activeItem]); // ✅ Add all dependencies

  const toggleSection = (itemName) => {
    setExpandedSections((prev) => ({
      ...prev,
      [itemName]: !prev[itemName],
    }));
  };

  const handleLogout = () => {
    console.log("Logging out...");
  };

  const LogOutUser = (name, domain) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/;`;
    localStorage.clear();
    window.location.href = "https://accredian.com";
  };

  const handleSidebarMouseEnter = (item) => {
    if (isCollapsed) {
      if (expandTimeout) {
        clearTimeout(expandTimeout);
      }
      const timeout = setTimeout(() => {
        setTempExpanded(true);
        // Auto-expand items with children
        if (item && item.children && item.children.length > 0) {
          setExpandedSections((prev) => ({
            ...prev,
            [item.name]: true,
          }));
        }
      }, 200);
      setExpandTimeout(timeout);
    }
  };

  const handleSidebarMouseLeave = () => {
    if (expandTimeout) {
      clearTimeout(expandTimeout);
    }
    if (tempExpanded) {
      setTempExpanded(false);
      setExpandedSections({});
    }
  };

  const handleItemClick = (item, parentId = null) => {
    // Generate unique ID for child items
    if (item.type === "modal") {
      setIsOpen(item.id); // This will set "shareFeedback" as the value
      return;
    }

    if (item.type === "external" && item.id == "events-calendar") {
      const newemail = btoa(localStorage.getItem("email"));
      window.open(item.link + newemail, "_blank");
      return;
    }

    if (item.type === "external") {
      window.open(item.link, "_blank");
      return;
    }

    if (item.type === "inclusion") {
      if (inclusion_link) {
        window.open(inclusion_link, "_blank");
      } else {
        window.open(item.link + "/" + program_inclusive_id, "_blank");
      }
      return;
    }
    console.log("came here");
    const itemId = parentId
      ? item.id || `${parentId}-${item.name.toLowerCase().replace(/\s+/g, "-")}`
      : item.id;

    setActiveItem(itemId);

    // Set active parent if this is a child item
    if (parentId) {
      setActiveParent(parentId);
    } else {
      setActiveParent("");
    }

    // Close temporary expansion after clicking
    if (tempExpanded) {
      setTempExpanded(false);
      setExpandedSections({});
    }
  };

  const handleTabClick = (tabName) => {
    navigate(`/?tab=${tabName}`);
    setActiveItem(tabName);
  };

  const renderNavItem = (item, isChild = false, parentId = null) => {
    const IconComponent = iconMap[item.icon] || Settings;

    // Generate unique ID for child items
    const itemId =
      isChild && parentId
        ? item.id ||
        `${parentId}-${item.name.toLowerCase().replace(/\s+/g, "-")}`
        : item.id;

    // Check if this item is active
    const isActive = activeItem === itemId;

    // Check if this is a parent item and one of its children is active
    const isParentActive = !isChild && activeParent === item.id;

    const isFeedbackTarget = item.id === "share-feedback" && showCoach;

    const navItemContent = (
      <div
        id={item.id === "share-feedback" ? "tour-dashboard-feedback" : undefined}
        className={`flex items-center gap-3 p-3 rounded-lg transition-all duration-200 cursor-pointer group ${isChild ? "ml-6" : ""
          } ${isActive || (isParentActive && isCollapsed && !tempExpanded)
            ? "bg-blue-600 text-white shadow-sm"
            : isFeedbackTarget
              ? "coach-pulse text-[#2f6bff]"
              : "hover:bg-gray-100 hover:text-gray-900 text-gray-600"
          }`}
        onClick={(e) => {
          if (item.children && !isChild && !tempExpanded) {
            toggleSection(item.name);
          } else {
            handleItemClick(item, parentId);
          }
        }}
        onMouseEnter={() => {
          if (!isChild) handleSidebarMouseEnter(item);
        }}
      >
        <IconComponent
          className={`w-5 h-5 flex-shrink-0 ${isActive || (isParentActive && isCollapsed && !tempExpanded)
            ? "text-white"
            : isFeedbackTarget
              ? "text-[#2f6bff]"
              : "text-gray-500 group-hover:text-gray-900"
            }`}
        />

        {(!isCollapsed || tempExpanded) && (
          <>
            <span
              className={`text-sm font-medium flex-1 ${isActive
                ? "text-white"
                : isFeedbackTarget
                  ? "text-[#2f6bff]"
                  : "text-gray-600 group-hover:text-gray-900"
                }`}
            >
              {item.name}
            </span>

            <div className="flex items-center gap-2">
              {item.badge && (
                <Badge className={`text-[10px] px-1.5 py-0.5 rounded-full ${item.badge.toUpperCase() === "NEW" ? "animate-fade-pulse" : ""} ${isActive ? "bg-white text-blue-600 shadow-sm" : "bg-red-500 text-white"}`}>
                  {item.badge}
                </Badge>
              )}
              {item.isNew && (
                <Badge className={`text-[10px] px-1.5 py-0.5 rounded-full animate-fade-pulse ${isActive ? "bg-white text-blue-600 shadow-sm" : "bg-blue-600 text-white"}`}>
                  New
                </Badge>
              )}
              {item.children &&
                (expandedSections[item.name] ? (
                  <ChevronDown className="w-4 h-4" />
                ) : (
                  <ChevronRight className="w-4 h-4" />
                ))}
            </div>
          </>
        )}
      </div>
    );

    // Only add Link wrapper if item has a link property
    const finalContent =
      item.link &&
        item.type !== "modal" &&
        item.type !== "external" &&
        item.type !== "inclusion" ? (
        <Link
          to={item.link}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {navItemContent}
        </Link>
      ) : (
        navItemContent
      );

    return (
      <div key={item.name} className="relative" ref={item.id === "share-feedback" ? feedbackItemRef : null}>
        {finalContent}

        {/* Nested children */}
        {item.children &&
          expandedSections[item.name] &&
          (!isCollapsed || tempExpanded) &&
          item.children.map((child) => (
            <div key={child.name}>
              {child.link && child.type !== "inclusion" ? (
                <Link
                  to={child.link}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {renderNavItem(child, true, item.id)}
                </Link>
              ) : (
                renderNavItem(child, true, item.id)
              )}
            </div>
          ))}
      </div>
    );
  };

  return (
    <>
      <style>{`
        @keyframes fade-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        .animate-fade-pulse {
          animation: fade-pulse 2s ease-in-out infinite;
        }

        @keyframes coach-in {
          0% { opacity: 0; transform: translate(-8px, -50%) scale(0.96); }
          100% { opacity: 1; transform: translate(0, -50%) scale(1); }
        }
        .animate-coach-in { animation: coach-in 350ms cubic-bezier(0.16, 1, 0.3, 1) both; }

        @keyframes coach-bounce {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(-8px); }
        }
        .coach-bounce { animation: coach-bounce 1.2s ease-in-out infinite; }

        @keyframes coach-pulse-ring {
          0% { box-shadow: 0 0 0 0 rgba(47,107,255, 0.55); }
          70% { box-shadow: 0 0 0 12px rgba(47,107,255, 0); }
          100% { box-shadow: 0 0 0 0 rgba(47,107,255, 0); }
        }
        .coach-pulse {
          background-color: #eef3ff !important;
          color: #2f6bff !important;
          animation: coach-pulse-ring 1.8s ease-out infinite;
        }

        @keyframes fade-in {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        .animate-fade-in {
          animation: fade-in 200ms ease-out both;
        }
      `}</style>
      <div
        className={`hidden md:fixed left-0 top-0 h-screen bg-white border-r border-gray-200 shadow-lg z-50 transition-all duration-300 md:flex md:flex-col ${isCollapsed && !tempExpanded ? "w-20" : "w-64"
          }`}
        onMouseLeave={handleSidebarMouseLeave}
      >
        {/* Header with Toggle */}
        <div className="flex items-center justify-between p-[12px] border-b border-gray-200">
          {(!isCollapsed || tempExpanded) && (
            <img
              onClick={() => {
                window.open("https://accredian.com", "_blank");
              }}
              className="h-10 ml-1 cursor-pointer"
              src="https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/other/logo.webp"
              alt="Accredian"
            />
          )}
          <div className="relative">
            <button
              onClick={() => setIsCollapsed(!isCollapsed)}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors group"
            >
              <Menu className="w-6 h-6 mb-2" />
            </button>
          </div>
        </div>

        {/* Navigation - Scrollable */}
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto custom-scrollbar">
          {location.pathname === "/studentDetails" ? (
            // Render only 2 tabs for home page
            <>
              <button
                onMouseEnter={() => handleSidebarMouseEnter(null)}
                className={`w-full flex items-center ${isCollapsed && !tempExpanded ? "justify-center" : "justify-between"
                  } gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 bg-blue-600 text-white`}
              >
                <div className="flex items-center gap-3">
                  <BookOpen size={20} />
                  {(!isCollapsed || tempExpanded) && (
                    <span className="font-medium">Student Details</span>
                  )}
                </div>
              </button>
            </>
          ) : (
            // Render normal sidebar items
            // sidebarData.map((item) => renderNavItem(item))
            <>
              {filteredSidebarData.map((item) => renderNavItem(item))}
              <Feedback open={isOpen} setOpen={setIsOpen} />
              <ShareFeedback open={isOpen} setOpen={setIsOpen} />
            </>
          )}
        </nav>

        {/* User Profile Section - Sticky at bottom */}
        <div className="border-t border-gray-200 p-4 bg-white">
          {isCollapsed && !tempExpanded ? (
            <div className="flex flex-col items-center space-y-2">
              <div className="relative group">
                <Avatar className="w-8 h-8 ring-2 ring-gray-200 cursor-pointer hover:ring-blue-600 transition-colors">
                  {user.avatar ? (
                    <img
                      src={user.avatar}
                      alt={user.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <AvatarFallback className="bg-gray-100 text-gray-600">
                      {(() => {
                        const nameParts = user.name.trim().split(" ");
                        const firstInitial = nameParts[0]?.charAt(0) || "";
                        const lastInitial =
                          localStorage
                            .getItem("lastname")
                            ?.split(" ")[0]
                            ?.charAt(0) || "";
                        return (firstInitial + lastInitial).toUpperCase();
                      })()}
                    </AvatarFallback>
                  )}
                </Avatar>
              </div>

              <div className="relative group">
                <button
                  onClick={() => {
                    LogOutUser("token", "accredian.com");
                  }}
                  className="p-2 rounded-lg hover:bg-gray-100 transition-colors group"
                >
                  <LogOut className="w-4 h-4 text-gray-500 group-hover:text-gray-900" />
                </button>
              </div>
            </div>
          ) : (
            <div className="space-y-3">
              {/* User Info */}
              <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                <Avatar className="w-10 h-10 ring-2 ring-gray-200">
                  {user.avatar ? (
                    <img
                      src={user.avatar}
                      alt={user.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <AvatarFallback className="bg-gray-100 text-gray-600">
                      {(() => {
                        const nameParts = user.name.trim().split(" ");
                        const firstInitial = nameParts[0]?.charAt(0) || "";
                        const lastInitial =
                          localStorage
                            .getItem("lastname")
                            ?.split(" ")[0]
                            ?.charAt(0) || "";
                        console.log(
                          localStorage.getItem("lastname")?.split(" ")[0]
                        );
                        return (firstInitial + lastInitial).toUpperCase();
                      })()}
                    </AvatarFallback>
                  )}
                </Avatar>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {user.name}
                  </p>
                  <p className="text-xs text-gray-500 truncate">{user.email}</p>
                </div>
              </div>

              {/* Logout Button */}
              <button
                onClick={() => {
                  LogOutUser("token", "accredian.com");
                }}
                className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-red-50 hover:text-red-600 transition-colors group"
              >
                <LogOut className="w-4 h-4" />
                <span className="text-sm font-medium">Logout</span>
              </button>
            </div>
          )}
        </div>
        {showCoach && targetRect && (
          <>
            <div
              onClick={handleDismissCoach}
              className="fixed inset-0 z-[998] bg-slate-900/10 backdrop-blur-[1px] animate-fade-in"
            />
            <div className="pointer-events-none fixed z-[999]" style={{ top: targetRect.top - 12, left: targetRect.left - 22 }}>
              <div className="coach-bounce">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M20 12L6 12M6 12L12 6M6 12L12 18" stroke="#2f6bff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
            <div className="fixed z-[999] w-[340px] -translate-y-1/2 animate-coach-in" style={{ top: targetRect.top, left: targetRect.left + 14 }}>
              <div className="relative rounded-2xl border border-slate-100 bg-white p-5 shadow-[0_20px_50px_-12px_rgba(47,107,255,0.35)]">
                <div className="absolute -left-2 top-1/2 -translate-y-1/2">
                  <div className="h-4 w-4 rotate-45 border-b border-l border-slate-100 bg-white" />
                </div>
                <div className="flex items-start justify-between">
                  <span className="rounded-full bg-gradient-to-r from-[#2f6bff] to-[#5b8dff] px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white shadow-sm">New</span>
                  <button onClick={handleDismissCoach} className="text-slate-400 hover:text-slate-600" aria-label="Dismiss">
                    <X className="h-4 w-4" />
                  </button>
                </div>
                <h3 className="mt-3 text-[17px] font-bold leading-snug text-slate-900">Dashboard Feedback has moved here</h3>
                <p className="mt-1 text-sm text-slate-500">Share Feedback is now your one place to reach us, enhanced with more ways to be heard:</p>
                <ul className="mt-3 space-y-1.5">
                  {["Suggest improvements", "Report issues", "Appreciate the team"].map(e => (
                    <li key={e} className="flex items-center gap-2 text-sm text-slate-700">
                      <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#eef3ff] text-[#2f6bff]">
                        <Check className="h-3 w-3" strokeWidth={3} />
                      </span>
                      {e}
                    </li>
                  ))}
                </ul>
                <div className="mt-5 flex items-center justify-end">
                  <button onClick={handleDismissCoach} className="rounded-lg bg-[#2f6bff] px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#255ae0]">Got it</button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Sidebar;

